import { BaseService } from "services/base-service";

import { API_ROUTES } from "constants/routes";

class SupportAgentsService extends BaseService {
  constructor(url, api) {
    super(url, api);
    this.getSupportAgents = this.getSupportAgents.bind(this);
  }

  async getSupportAgents(params) {
    try {
      const response = await this.agent.get("", params);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async getCurrentSupportAgent(params) {
    try {
      const response = await this.agent.get("/current", params);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }
}

const ServiceInstance = new SupportAgentsService(API_ROUTES.supportAgents);

export default ServiceInstance;
export { ServiceInstance as SupportAgentsService };
